import { IConversation } from "@/types";

export const createConversation = async (): Promise<IConversation> => {
  const response = await fetch(
    "https://prod-api.tavus.io/proxy/rqh/v2/conversations",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "7a69ffc48b2640f897ec1b72c0720533",
      },
      body: JSON.stringify({
        // Replace with your own Persona ID
        persona_id: "p58040634b04", // Santa's unique persona ID in Tavus
        replica_id: "r4dcf61c154d", // Santa's unique replica ID
        conversation_name: "Vlad Sadovskiy", // Name of the Santa-themed conversation
        conversational_context: "You are about to talk to Vlad Sadovskiy", // Adds context for the conversation
        custom_greeting: "Hey are you here? I'm kinda running out of time", // Santa's iconic greeting
        properties: {
          language: "english", // Language for the conversation (30 avalible languages!)
        },
      }),
    },
  );

  if (!response?.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};
